import React from 'react'
import Modal from 'react-bootstrap/Modal'

const TheatreModal = (props) => {
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      style={{
        userSelect: 'none',
      }}
      size={20}
      //   backdrop='static'
      centered
    >
      <Modal.Body className=''>
        {props.data?.map((item) => (
          <div
            className='ilceItem'
            key={item.theatre_id}
            onClick={() => {
              const date = item?.seans?.length === 1 ? item?.seans[0].date : null
              const dateId = item?.seans?.length === 1 ? item?.seans[0].date_id : null

              const newSayi = item?.seans?.length === 1 && item?.seans[0]?.hours?.length === 1 ? item?.seans[0]?.hours[0]?.sayi : null
              const newHour = item?.seans?.length === 1 && item?.seans[0]?.hours?.length === 1 ? item?.seans[0]?.hours[0]?.hour : null
              const newHourId = item?.seans?.length === 1 && item?.seans[0]?.hours?.length === 1 ? item?.seans[0]?.hours[0]?.hour_id : null
              const newDoluluk = item?.seans?.length === 1 && item?.seans[0]?.hours?.length === 1 ? item?.seans[0]?.hours[0]?.doluluk : null
              const kalan_bilet = item?.seans?.length === 1 && item?.seans[0]?.hours?.length === 1 ? item?.seans[0]?.hours[0]?.kalan_bilet : null
              const kalanKullanimHakki = item?.seans?.length === 1 && item?.seans[0]?.hours?.length === 1 ? item?.seans[0]?.hours[0]?.kalan_kullanim_hakki : null

              const newAges = item?.ages ?? ''
              props.setAges(newAges)

              const etkinlikTuru = item?.etkinlik_turu_aciklama ?? ''
              props.setEtkinlikTuru(etkinlikTuru)
              
              const kisiTuru = item?.kisi_turu ?? ''
              props.setKisiTuru(kisiTuru)

              props.setSayi(newSayi)
              props.setSelectedTheatre(item)
              props.setSelectedDate(date)
              props.setSelectedDateId(dateId)
              props.setDoluluk(newDoluluk)
              props.setSelectedSeans(newHour)
              props.setSelectedSeansId(newHourId)

              if (kalan_bilet) {
                props.setTicketCount(kalan_bilet < kalanKullanimHakki ? kalan_bilet : kalanKullanimHakki)
                props.setKalanBiletSayisi(kalan_bilet)
              }
              props.onHide()
            }}
          >
            {item.theatre_name}
          </div>
        ))}
        <div style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={props.onHide}>
          X
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default TheatreModal
